// @ts-nocheck
/* eslint-disable */
import { node, icon } from "~/util/dom";
import { addListener, makeEvent } from "~/lib/signals";
import { CONFIG } from "~/config";
import ContentFull from "~/content.full";
import ContextMenu from "~/ui/contextmenu";
import ContextMenuItem from "~/ui/contextmenuitem";
import Report from "~/report";
import { getReportPanoramaOptions } from "~/report/options";
import { reportWaitForLogin, reportAnalytics } from "~/report/util";
import { _ } from "~/i18n";
import Scene from "~/scene";
import { store } from "~/state/store";
import { setMapset, setCoordinates } from "~/state/map/state";
import { MAP_OVERLAYS } from "~/state/map/constants";
import SceneCoords from "~/scene/common/coords";
import { getPanoAtCoords, getPanoByPid, openPanoramaAt, PANO_BACKEND_URL } from "./util/providers/pano";
import { Scene as PanoScene, Utils as PanoUtils } from "@mapy/panorama/dist/panorama-private";
import WasmStoreMarker from "./wasm/store/wasm-store-marker";
import { WASM_ZINDEX } from "./wasm/const";

/**
 * Komponenta na zobrazovani panoramat v sirkach 2 a 3. Sourozenec od Mapy.M3D.
 * @signal pano-activate
 * @signal pano-deactivate
 * @signal pano-year
 */
Mapy.Pano = class extends ContentFull {
	_markerCoords: SceneCoords;

	_panoScene: PanoScene;

	_layer: any;

	_wasmMarker: WasmStoreMarker;

	constructor() {
		super();

		this._contentName = "pano";
		this._yaw = null; /* natoceni; pamatujeme od minula */
		this._panoScene = null; /* PanoScene */
		this._id = null; /* ID dokud cekame na place */
		this._placeId = null;
		this._dragging = false; /* probiha tazeni? */
		this._keyboardMode = 0; /* jak API ovlada klavesnici? */
		this._markerCoords = Scene.coordsFromWGS84(14, 50);
		this._ss = [];
		this._panoUnsupported = false;
		this._isPanoLayerOpen = false;
		this._layer = Scene.createLayerMarker();
		this._panoMarker = Scene.createMarkerMapyPano();
		this._panoMarker.setCoords(this._markerCoords);
		this._panoMarker.decorateDraggable();
		this._wasmMarker = new WasmStoreMarker({
			type: "pano",
			visible: false,
			draggable: true,
			zIndex: WASM_ZINDEX.marker.pano,
			interactionType: "click-hover",
		});

		this._dom = {
			container: node("div", { id: "panorama" }),
			buttons: node("div", { className: "buttons" }),
			opts: node("div", { className: "pano-opts" }),
		};

		if (!PanoUtils.isSupported()) {
			this._panoUnsupported = true;

			this._dom.container.appendChild(Mapy.Util.createBigOldBrowserInfo(true));
		}

		this._buildCloseButton();
		this._buildOpts();
		this._buildFullscreenButton();

		this._dom.closeButton.classList.add("pano-btn");

		const closeBtn = node("button", { className: "pano-btn-back" });
		closeBtn.append(icon("close"), node("span", { textContent: _("close") }));
		closeBtn.addEventListener("click", e => {
			this._clickClose();
		});
		this._dom.buttons.append(closeBtn);

		this._camera = {
			fov: 0,
			pitch: 0
		};
		this._year = 0;

		this._lastCenter = null;

		// signal pano-change, 3/4 sekundy pro vyvolani, bindovani funkce kvuli setTimeout
		this._panoChangeObj = {
			id: null,
			timeout: 750,
			updateUrl: this._updateUrl.bind(this)
		};

		addListener(this, "resize", "_resize");
		addListener(this, "width-change-start", "_widthChange");
		addListener(this, "width-change", "_widthChange");
		addListener(this, "print-page", "_printPage");
		addListener(this, "print-done", "_printDone");
	}

	activate() {
		if (this.isActive()) { return this; }
		super.activate();

		makeEvent("pano-activate", this);

		if (CONFIG.inFrame) {
			document.body.classList.add("pano");
		}

		const state = store.getState();
		const { mapset, longitude, latitude } = state.map;
		const overlays = mapset in state.map.currentOverlays ? state.map.currentOverlays[mapset] : [];

		this._isPanoLayerOpen = overlays.indexOf(MAP_OVERLAYS.PANORAMA) !== -1;

		if (!this._isPanoLayerOpen) {
			store.dispatch(setMapset({
				mapset,
				overlays: [...overlays, MAP_OVERLAYS.PANORAMA],
			}));
		}

		if (this._panoUnsupported) {
			// marker - def. z API
			this._panoMarker.getContainer(function(el) {
				el.classList.add("uns-pano-marker");
			}, null, true);
			this._layer.addMarker(this._panoMarker);
			Scene.addLayer(this._layer).enable();

			//this._appendCloseButton();
			this._changeFullscreen();
			this._syncPort();
			return this;
		}

		this._panoScene = new PanoScene(this._dom.container, {
			apiKey: CONFIG.mapiKey,
			url: PANO_BACKEND_URL,
			nav: true,
			logoType: "panorama",
			lang: CONFIG.defaultLang,
			onSignal: (name, data) => {
				switch (name) {
					case "marker-set-angle":
						this._panoMarker.setAngle(data.angle);
						this._wasmMarker.update({
							angle: data.angle,
						});
						break;

					case "marker-set-coords":
						this._panoMarker.setCoords(Scene.coordsFromWGS84(data.lon, data.lat));
						this._wasmMarker.update({
							lon: data.lon,
							lat: data.lat,
						});
						break;

					case "pano-change":
						this._panoChange();
						break;

					default:
				}
			},
		});
		this._panoScene.addTimeline(this._dom.buttons, (name, data) => {
			switch (name) {
				case "pano-timeline":
					this._year = data.year;
					makeEvent("pano-year", this, { year: data.year });
					Mapy.getComponent("history").save(true);
					break;

				case "pano-open":
					if (data.years.length) {
						data.years[0] = "Nejnovější";
					}

					Mapy.getComponent("logger").log("click", {
						text: "panoramaTimelineShow",
						values: data.years,
					});
					break;

				case "pano-close":
					if (data.years.length) {
						data.years[0] = "Nejnovější";
					}

					Mapy.getComponent("logger").log("click", {
						text: "panoramaTimelineHide",
						values: data.years,
					});
					break;

				case "pano-year-select":
					Mapy.getComponent("logger").log("click", {
						text: "panoramaTimelineSelect",
						value: data.year,
					});
					break;

				default:
					//
			}
		});

		this._layer.addMarker(this._panoMarker);

		Scene.addLayer(this._layer).enable();
		Scene.syncPort();

		this._ss.push(Scene.addListener("marker-drag-start", "_markerDragStart", this, this._panoMarker));
		this._ss.push(Scene.addListener("marker-drag-stop", "_markerDragStop", this, this._panoMarker));
		this._ss.push(Scene.addListener("marker-change", "_markerChange", this, this._panoMarker));
		document.addEventListener("fullscreenchange", this, false);

		if (!CONFIG.inFrame) {
			this._dom.container.appendChild(this._dom.fullscreenButton);
		}

		this._dom.container.append(this._dom.opts);
		//this._appendCloseButton();
		this._changeFullscreen();
		this._syncPort();

		/* deaktivovat ovladani api klavesnici */
		var keyboard = Scene.getKeyboardControl();

		if (keyboard) {
			this._keyboardMode = keyboard.getMode();
			keyboard.configure(0);
		}

		return this;
	}

	deactivate() {
		if (!this.isActive()) { return this; }

		// reset timeline
		this._year = 0;
		makeEvent("pano-year", this, { year: 0 });

		// odstraneni pano timeline tlacitka
		const panoTimelineEl = this._dom.buttons.querySelector(".panorama-timeline");

		if (panoTimelineEl) {
			panoTimelineEl.remove();
		}

		this._removeCloseButton();
		this._dom.opts.remove();
		Mapy.getComponent("history").setRewriteMode(false);

		if(this._layer.isActive()) {
			this._layer.removeAll();
			this._layer.disable();
			Scene.removeLayer(this._layer);
			Scene.removeListeners(this._ss);
		}

		if (this._panoScene) {
			this._panoScene.destroy();
			this._panoScene = null;
		}

		this._wasmMarker.update({
			visible: false,
		});

		this._panoChangeClear();

		this._placeId = null;
		this._lastCenter = null;

		const state = store.getState();
		const { mapset } = state.map;
		const overlays = mapset in state.map.currentOverlays ? [...state.map.currentOverlays[mapset]] : [];
		const panoramaIndex = overlays.indexOf(MAP_OVERLAYS.PANORAMA);

		if (panoramaIndex !== -1) {
			overlays.splice(panoramaIndex, 1);
		}

		if (!this._isPanoLayerOpen) {
			store.dispatch(setMapset({
				mapset,
				overlays,
			}));
		}
		this._isPanoLayerOpen = false;

		/* reaktivovat ovladani api klavesnici */
		var keyboard = Scene.getKeyboardControl();

		if (keyboard) {
			keyboard.configure(this._keyboardMode);
		}

		super.deactivate();

		makeEvent("pano-deactivate", this);
		document.removeEventListener("fullscreenchange", this, false);

		return this;
	}

	getYear() {
		return this.isActive() ? this._year : 0;
	}

	show() {
		Mapy.CML.state = {
			route: {
				showGeometries: true
			}
		};
		this._dom.container.append(this._dom.buttons);
		return super.show();
	}

	canIClosePanoLayer() {
		var m = !this._isPanoLayerOpen;
		return m;
	}

	getContainer() {
		return this._dom.container;
	}

	getCoords() {
		if (this._panoScene) {
			return this._panoScene.getPlace().getCoords();
		}
		else {
			const { longitude, latitude } = store.getState().map;

			return Scene.coordsFromWGS84(longitude, latitude);
		}
	}

	setState(state) {
		if ("pid" in state || "place" in state) {
			// reset hodnot
			let oldYear = this.isActive() ? this._year : null;

			this._camera.fov = 0;
			this._camera.pitch = 0;
			this._year = 0;
			this._yaw = null;

			if (state.p == "3" && state.pid) {
				this._ogPanoDetail(state);
				return;
			}

			if (state.fov) {
				var fov = parseFloat(state.fov);

				if (!isNaN(fov)) {
					this._camera.fov = fov;
				}
			}

			if (state.pitch) {
				var pitch = parseFloat(state.pitch);

				if (!isNaN(pitch)) {
					this._camera.pitch = pitch;
				}
			}

			this.activate();

			if (this._panoScene) {
				if ("yaw" in state) { this._yaw = parseFloat(state.yaw); }
				this._id = parseInt(state.pid);

				if (state.place) {
					this._response(state.place);
				} else {
					let prom = null;
					let setYear = false;

					const newest = parseInt(state.newest || "0");

					if (newest) {
						const { longitude, latitude } = store.getState().map;

						prom = getPanoAtCoords({
							lon: longitude,
							lat: latitude,
						});
					} else {
						setYear = true;
						prom = getPanoByPid({
							pid: this._id,
						});
					}

					prom.then(place => {
						if (oldYear !== null) {
							this._year = oldYear;
						} else if (setYear) {
							this._year = place.getDate().getFullYear();
						}

						this._response(place);
					}, e => {
						this._responseError(e);
					});
				}
			}
		}
		else if ("panous" in state) {
			this.activate();
		}
		else {
			this.deactivate();
		}
	}

	getState() {
		if(this._panoScene) {
			var obj = {
				pid: this._id || this._panoScene.getPlace()?.getId() || "",
				newest: !this._year ? 1 : 0,
			};

			if (this._yaw !== null) {
				obj["yaw"] = this._yaw.toFixed(3);
			}
			if (this._camera.fov !== 0) {
				obj["fov"] = this._camera.fov.toFixed(3);
			}
			if (this._camera.pitch !== 0) {
				obj["pitch"] = this._camera.pitch.toFixed(3);
			}

			const place = this._panoScene.getPlace();

			if (place) {
				const coords = place.getCoords();

				obj.x = coords[0].toFixed(5);
				obj.y = coords[1].toFixed(5);
			}

			return obj;
		}
		else if (this._panoUnsupported) {
			return {
				"panous": "1"
			};
		}
		else {
			return {}
		}
	}

	syncPort() {
		this._syncPort();
	}

	redraw() {
		if (!this.isActive()) { return; }
		if (this._panoScene) {
			this._panoScene.redraw();
		}
	}

	getDataUrl() {
		return this._panoScene.getRenderer().getDataUrl().promise;
	}

	/**
	 * Posluchac signalu "resize"
	 */
	_resize(e) {
		this._syncPort();
	}

	_widthChange(e) {
		if (!this.isActive()) { return; }
		switch(e.type) {
			case "width-change":
				if (Mapy.getComponent("layout").getWidth() < 2 && Mapy.getComponent("print").isPrinting) {
					this._printPromise.resolve();
					this._printPromise = null;
					return;
				}
				this._syncPort();
			break;

			case  "width-change-start":
				if (Mapy.getComponent("print").isPrinting) { return; }
				if (e.data.newWidth < 2) { this.deactivate(); }
			break;
		}
	}

	/**
	 * Mame data pro vyrobu sceny
	 */
	_response(place: any) {
		this._id = null; /* uz necekame */
		var obj = {
			yaw: this._yaw === null
				? "auto"
				: this._yaw,
		};

		var cameraSettings = {};

		if (this._camera.fov) {
			cameraSettings.fov = this._camera.fov;
		}
		if (this._camera.pitch) {
			cameraSettings.pitch = this._camera.pitch;
		}
		if (this._year) {
			obj.year = this._year;
		}

		Mapy.getComponent("history").setRewriteMode(true);
		this._panoScene?.show(place, obj);
		this._panoScene?.setCamera(cameraSettings);

		const [longitude, latitude] = place.getCoords();

		this._panoMarker.setCoords(Scene.coordsFromWGS84(longitude, latitude));
		this._wasmMarker.update({
			lon: longitude,
			lat: latitude,
			visible: true,
		});

		this._placeId = place.getId();
	}

	_responseError(data) {
		data = data.data || {};

		if (data.status == 404) {
			Mapy.setPhantomMeta(404);
			this.deactivate();
		}
	}

	_syncPort() {
		if (!this.isActive()) { return; }
		super._syncPort();
		if(this._panoScene) {
			this._panoScene.syncPort();
		}
	}

	/**
	 * Posluchac signalu marker-drag-start
	 */
	_markerDragStart(e) {
		this._dragging = true;
	}

	/**
	 * Posluchac signalu marker-drag-stop
	 */
	_markerDragStop(e) {
		this._dragging = false;

		/* ...a optame se na nejblizsi panorama */
		const wgs84 = this._panoMarker.getCoords().toWGS84();
		const zoom = store.getState().map.zoom;
		const selYear = Mapy.getComponent("pano").getYear();

		openPanoramaAt({
			lon: wgs84[0],
			lat: wgs84[1],
			zoom,
			selYear,
		}).then(() => {
			Mapy.getComponent("history").save();
		}, () => {});
	}

	/**
	 * Posluchac signalu marker-change - kdyz se zmeni znacce pozice (tj. zmena place)
	 */
	_markerChange(e) {
		if (this._dragging) { return; } /* pokud se pozice meni tazenim, ignore */
		var marker = this._panoMarker.getCoords();

		if (!this._markerCoords.equals(marker)) {
			const [longitude, latitude] = marker.toWGS84();

			this._markerCoords = marker;
			store.dispatch(setCoordinates({
				longitude,
				latitude,
				animate: true,
			}));
		}
	}

	handleEvent(event) {
		super.handleEvent(event);

		if (event.type == "keydown") {
			var keyCode = event.which || event.keyCode;
			const target = (event.target as HTMLElement).nodeName.toLowerCase();

			if (["input", "select", "option", "textarea"].indexOf(target) !== -1) {
				return;
			}

			var direction = 0;

			switch (keyCode) {
				// +
				case 107:
				case 49:
					direction = 1;
					break;

				// -
				case 109:
				case 189:
					direction = -1;
					break;
			}

			if (direction != 0) {
				event.preventDefault();

				var delta = direction / -20;

				var fov = this._panoScene.getCamera().fov + delta;
				this._panoScene.setCamera({
					fov: fov
				});
			}
		} else if (event.type == "fullscreenchange") {
			this._dom.container.classList[document.fullscreenElement ? "add" : "remove"]("fullscreen");
			this._syncPort();
		}
	}

	_updateUrl() {
		if (!this._panoScene) return;

		var camera = this._panoScene.getCamera();
		var id = this._panoScene.getPlace().getId();
		const [longitude, latitude] = this._panoScene.getPlace().getCoords();
		const coords = Scene.coordsFromWGS84(longitude, latitude);

		if (this._lastCenter && !this._lastCenter.equals(coords)) {
			store.dispatch(setCoordinates({
				longitude,
				latitude,
				animate: true,
			}));
		}

		this._lastCenter = coords;

		if (this._yaw != camera.yaw || this._camera.fov != camera.fov || this._camera.pitch != camera.pitch || id != this._placeId) {
			this._yaw = camera.yaw;
			this._camera.fov = camera.fov;
			this._camera.pitch = camera.pitch;
			this._placeId = id;
			Mapy.getComponent("history").save(true);
		}
	}

	getScene() {
		return this._panoScene;
	}

	_panoChange() {
		this._panoChangeClear();
		this._panoChangeObj.id = setTimeout(this._panoChangeObj.updateUrl, this._panoChangeObj.timeout);
	}

	_panoChangeClear() {
		if (this._panoChangeObj.id) {
			clearTimeout(this._panoChangeObj.id);
			this._panoChangeObj.id = null
		}
	}

	/**
	 * Open graph detail.
	 *
	 * @param  {Object} state Stav z url
	 */
	_ogPanoDetail(state) {
		Mapy.getComponent("loader").start();
		// fb rozmery 1200x630
		var width = Math.min(1200, window.innerWidth);
		var height = Math.min(630, window.innerHeight);
		var src = Mapy.Util.panoCompose(Object.assign({}, state, {
			width: width,
			height: height
		}));
		// fotka panoramy
		var img = node("img", { id: "panoPrintImg", src, width, height, crossOrigin: "anonymous" });
		Object.assign(img.style, { position: "absolute", top: 0, left: 0, width: "100%", height: "100%" });
		img.addEventListener("load", e => {
			Mapy.getComponent("loader").end();
		});
		img.addEventListener("error", e => {
			Mapy.getComponent("loader").end();
		});
		document.body.appendChild(img);
		// mapa - do praveho ramecku
		var mapEl = document.getElementById("map");
		mapEl.style.width = "400px";
		mapEl.style.height = "225px";
		// skryjeme detail
		var detail = document.querySelector("#detail");
		if (detail) {
			detail.style.display = "none";
		}
		var mapCont = node("div", { className: "map-content" });
		mapCont.appendChild(mapEl);
		document.body.appendChild(mapCont);

		Scene.syncPort();

		// ocicko marker do mapy
		const { longitude, latitude, zoom } = store.getState().map;
		var coords = "x" in state && "y" in state ? Scene.coordsFromWGS84(parseFloat(state.x), parseFloat(state.y)) : Scene.coordsFromWGS84(longitude, latitude);
		var marker = Scene.createMarkerMapyPano(coords);
		const [lon, lat] = coords.toWGS84();
		const markerAngle = state.yaw ? Math.round(parseFloat(state.yaw) / Math.PI * 180) : 0

		marker.setAngle(markerAngle);
		this._wasmMarker.update({
			angle: markerAngle,
		});
		this._layer.addMarker(marker);
		Scene.addLayer(this._layer).enable();
		store.dispatch(setCoordinates({
			longitude: lon,
			latitude: lat,
			zoom: "z" in state ? parseFloat(state.z) : zoom,
			animate: true,
		}));
	}


	/**
	 * Nastaví vyrobí tiskovou promisi, přidá ji do závislostí a spustí zmenšení plachty (aby v tisku nebyla malá mapa)
	 */
	_printPage() {
		if (!this.isActive() || Mapy.getComponent("print").mode === 4) { return; }

		if (document.fullscreenElement) { document.exitFullscreen(); }
		this._printPromise = Mapy.Util.createPrintPromise();
		Mapy.getComponent("print").addDepends(this._printPromise);
		Mapy.getComponent("layout").setWidth(1);
	}

	/**
	 * Po dokončení printscreenování mapy nastaví šířku plachty opět na velkou
	 */
	_printDone() {
		if (!this.isActive()) { return; }

		Mapy.getComponent("layout").setWidth(2);
	}

	_buildOpts() {
		const optsBtn = node("button", { className: "pano-opts-btn" });
		const menu = node("div");
		const contextMenu = new ContextMenu({
			anchor: optsBtn,
			content: menu,
			position: "bottom-end",
			className: "report-panorama-problem",
			popOverParent: this._dom.container,
			offset: 16,
		});
		const editMenuItem = new ContextMenuItem({
			icon: null,
			text: _("mymap.contextMenu.report"),
			onClick: async () => {
				contextMenu.close();
				reportAnalytics({
					text: "Nahlásit problém",
					section: "panorama",
				}, "click");

				await reportWaitForLogin();

				const report = new Report(getReportPanoramaOptions(this._placeId, Mapy.getComponent("layout").getScrollNode()));

				report.open();
			},
		});

		editMenuItem.container.setAttribute("data-log-ignore", "1");
		menu.append(editMenuItem.container);
		optsBtn.addEventListener("click", () => {
			contextMenu.toggle();
		});
		optsBtn.append(
			icon("etc"),
		);
		this._dom.opts.append(optsBtn);
	}
};
